export enum DropdownActionsEnum {
  DIVIDER = -1,
  DELETE = 1,
  DOWNLOAD = 2,
  DUPLICATE = 3,
  EMAIL = 4,
  PRINT = 5,
  VIEW = 6,
  CHANGE_DOC_NUM = 7,
  EDIT = 8,
  UNDO = 9,
  ENABLE = 10,
  DISABLE = 11,
  IMPORT_PRIMAVERA = 12,
  IMPORT_MICROSOFT_PROJECT = 13,
  ACTIONS_GROUP = 14,
  CLOSE_CONTRACT = 15,
  EXPORT_DATA = 16,
  VIEW_DATA_EXPORTS = 17,
  REOPEN = 18,
  ARCHIVE = 19,
  REGENERATE_PDF = 20,
}

export type DropdownItem = {
  id: DropdownActionsEnum;
  icon: string;
  label?: string;
};

export type DropdownActionsList = (keyof typeof DropdownActionsEnum)[];

export const DROPDOWN_ITEMS: Record<keyof typeof DropdownActionsEnum, DropdownItem> = {
  CHANGE_DOC_NUM: {
    id: DropdownActionsEnum.CHANGE_DOC_NUM,
    icon: 'numbers',
    label: 'actions.changeDocNum',
  },
  DELETE: {
    id: DropdownActionsEnum.DELETE,
    icon: 'delete_outline',
    label: 'actions.delete',
  },
  DIVIDER: {
    id: DropdownActionsEnum.DIVIDER,
    icon: '',
  },
  DOWNLOAD: {
    id: DropdownActionsEnum.DOWNLOAD,
    icon: 'get_app',
    label: 'actions.download',
  },
  DUPLICATE: {
    id: DropdownActionsEnum.DUPLICATE,
    icon: 'content_copy',
    label: 'actions.duplicate',
  },
  EMAIL: {
    id: DropdownActionsEnum.EMAIL,
    icon: 'forward_to_inbox',
    label: 'actions.email',
  },
  PRINT: {
    id: DropdownActionsEnum.PRINT,
    icon: 'print',
    label: 'actions.print',
  },
  EDIT: {
    id: DropdownActionsEnum.EDIT,
    icon: 'edit',
    label: 'actions.edit',
  },
  VIEW: {
    id: DropdownActionsEnum.VIEW,
    icon: 'visibility',
    label: 'actions.view',
  },
  UNDO: {
    id: DropdownActionsEnum.UNDO,
    icon: 'undo',
    label: 'actions.undoLastAction',
  },
  ENABLE: {
    id: DropdownActionsEnum.ENABLE,
    icon: 'toggle_on',
    label: 'actions.enable',
  },
  DISABLE: {
    id: DropdownActionsEnum.DISABLE,
    icon: 'toggle_off',
    label: 'actions.disable',
  },
  ACTIONS_GROUP: {
    id: DropdownActionsEnum.ACTIONS_GROUP,
    icon: 'ads_click',
    label: 'actions.actions',
  },
  IMPORT_PRIMAVERA: {
    id: DropdownActionsEnum.IMPORT_PRIMAVERA,
    icon: 'file_upload',
    label: 'actions.importPrimaveraFile',
  },
  IMPORT_MICROSOFT_PROJECT: {
    id: DropdownActionsEnum.IMPORT_MICROSOFT_PROJECT,
    icon: 'file_upload',
    label: 'actions.importMicrosoftProjectFile',
  },
  CLOSE_CONTRACT: {
    id: DropdownActionsEnum.CLOSE_CONTRACT,
    icon: 'lock',
    label: 'actions.closeContract',
  },
  EXPORT_DATA: {
    id: DropdownActionsEnum.EXPORT_DATA,
    icon: 'ios_share',
    label: 'actions.exportData',
  },
  VIEW_DATA_EXPORTS: {
    id: DropdownActionsEnum.VIEW_DATA_EXPORTS,
    icon: 'history',
    label: 'actions.viewDataExports',
  },
  REOPEN: {
    id: DropdownActionsEnum.REOPEN,
    icon: 'settings_backup_restore',
    label: 'actions.reopen',
  },
  ARCHIVE: {
    id: DropdownActionsEnum.ARCHIVE,
    icon: 'archive',
    label: 'actions.archive',
  },
  REGENERATE_PDF: {
    id: DropdownActionsEnum.REGENERATE_PDF,
    icon: 'picture_as_pdf',
    label: 'actions.regeneratePdf',
  },
} as const;
